let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("grN7i")).then(() => parcelRequire('l283Y'));